import { render, staticRenderFns } from "./DealerDefinedFees.vue?vue&type=template&id=20f4eddd&scoped=true&"
import script from "./DealerDefinedFees.vue?vue&type=script&lang=js&"
export * from "./DealerDefinedFees.vue?vue&type=script&lang=js&"
import style0 from "./DealerDefinedFees.vue?vue&type=style&index=0&id=20f4eddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4eddd",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/DealerDefinedFees.vue
// module id = null
// module chunks = 